import { Board } from "@common-models/board"
import { createAsyncThunk } from "@reduxjs/toolkit"

import { bulkActions, getBulkTaskList } from "./BulkActionsReducer"
import { mainSliceActions } from "./MainReducer"
import { UndoRedoAction } from "./UndoRedoReducer"
import { doActionThunk } from "./UndoRedoThunks"
import { CommonRootState } from "@common/types/common-root-state-type"

export const moveGroupToBoardThunk = createAsyncThunk<void, Board, { state: CommonRootState }>
    ('bulkActions/moveGroupToBoardThunk', async (board, thunkAPI) => {
    const dispatch = thunkAPI.dispatch

    dispatch(bulkActions.setIsBulkActionsDialogOpen(false))
    
    dispatch(bulkActions.setMovingTo(""))
    dispatch(bulkActions.setGroupIsMoving(false))
    dispatch(mainSliceActions.toggleGroupMenu(''))

})

type DeleteTasksParams = {
    deletedOrArchived: string;
    /** See UndoRedoAction.itemLabel ('contact' when the rows are an audience's). */
    itemLabel?: string;
  };

  export const deleteOrArchiveSelectedTasks = createAsyncThunk<
  void, 
  DeleteTasksParams, 
  { state: CommonRootState }
>
('bulkActions/deleteOrArchiveSelectedTasks', async (params, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    const state = thunkAPI.getState();

    const bulkTaskList = getBulkTaskList(state);
    
    const action: UndoRedoAction<string[], string> = {
        type: 'delete-task-list',
        data: bulkTaskList.map(task => task._id).filter((id): id is string => id !== undefined),
        deletedOrArchived: params.deletedOrArchived,
        itemLabel: params.itemLabel,
    };

    dispatch(doActionThunk({ action }));
    dispatch(bulkActions.setBulkTasksMap({}));
})
